import { ShieldAlert } from "lucide-react";

export default function ComplianceCard() {
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-6 md:-mt-10 relative z-10">
      <div
        data-testid="compliance-disclosure"
        className="rounded-2xl bg-white border border-gray-200 shadow-[0_12px_32px_rgba(15,45,82,0.06)] p-5 md:p-6 flex flex-col md:flex-row gap-4 md:items-start"
      >
        <div className="w-10 h-10 rounded-xl bg-[#0F2D52]/5 flex items-center justify-center shrink-0">
          <ShieldAlert className="h-5 w-5 text-[#0F2D52]" />
        </div>
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1">
            <span className="text-[10px] uppercase tracking-[0.16em] font-bold text-[#D4AF37]">
              Important Disclosure
            </span>
          </div>
          <p className="text-sm text-gray-700 leading-relaxed">
            Money Mart is an independent Bank Channel Partner (DSA) and does not provide loans directly.
            Loan approvals, interest rates, processing fees, tenure and all lending decisions are determined solely by the respective Bank or NBFC, subject to their eligibility criteria and applicable regulations.
          </p>
        </div>
      </div>
    </section>
  );
}
